import React, { Component } from "react";
import { bounceIn, Button2, HelmetR, VerticalSwiperV2 } from "../../components";
import styles from "./HomeV3.module.scss";
import { CTASection, LabelTestimonials, LandingV3 } from "../../sections";
import { ReactComponent as PlayButton } from "../../assets/SVGs/play.svg";
import NewsV2 from "../../sections/NewsV2";
import CUSTOMIZE_IMG from "../../assets/images/customize.webp";
import CONTROL_IMG from "../../assets/images/Combined Graphs.webp";
import { DEAL_COMPARISON, FUNDING_NETWORK, FUNDING_NETWORK_ARTIST, FUNDING_NETWORK_LABEL, GetIframeVideo } from "../../routes/constants";
import FeaturedVideo from "../../sections/FeaturedVideo";
import SnapSection from "../../components/SnapSection/SnapSection";
import { HOMEPAGE_DEFAULT_CATEGORY } from "../ArticlePage/constant";
import { motion } from "motion/react";

class HomeV3 extends Component {
  render() {
    return (
      <>
        <HelmetR />
        <SnapSection>
          <LandingV3 />
        </SnapSection>
        <SnapSection light >
          <motion.div className={styles.intro} {...bounceIn}>
            <GetIframeVideo
              className={styles.video}
              url="https://www.youtube.com/watch?v=1VB8crJMjrs=3s"
              loading="lazy"
              themeplay="true"
            />
            <div className={styles.introContent}>
              <div className={styles.introText}>
                <h2>What is beatBread?</h2>
                <p className={styles.description}>beatBread is the place where artists and labels get more choices and better funding. Our deals range from $1,000 to over $10,000,000. We help artists and labels compare their options, even if they choose funding from a competitor.</p>
              </div>
              <FeaturedVideo className={styles.actionButton} video="https://www.youtube-nocookie.com/embed/1VB8crJMjrs?si=xejEik5b1oK1HzyE&rel=0&autoplay=1&mute=1&modestbranding=1">
                <Button2 dark tertiary><PlayButton/><p>Learn More</p></Button2>
              </FeaturedVideo>
            </div>
          </motion.div>
        </SnapSection>
          <VerticalSwiperV2>
            <div className={styles.videoSlide}>
              <div className={styles.description}>
                <h2>More Choices</h2>
                <p>Choose your term length, recoupment rate, and whether to include new music.<br /> <br />Qualifying artists and labels can access offers from multiple distributors and finance companies and even explore an outright sale of their catalog.</p>
              </div>
              <img className={styles.content} src={CUSTOMIZE_IMG} alt=""/>
            </div>
            <div className={styles.videoSlide}>
              <div className={styles.description}>
                <h2>More Clarity</h2>
                <p>Compare and analyze multiple offers and the trade offs between funding amounts, term length and cost.<br/><br/>Understand cash flows of different deals under different performance scenarios.</p>
              </div>
              <img className={styles.content} src={CONTROL_IMG} alt=""/>
            </div>
            <div className={styles.videoSlide}>
              <div className={styles.description}>
                <h2>More Control</h2>
                <p>Stay on your current distributor or switch to a new one for better services, or lower fees. <br/> <br/>Pick the right deal for you, whether it’s from beatBread, our partners, or a competitor.</p>
              </div>
              <GetIframeVideo
                className={styles.content}
                url="https://youtu.be/ZitSiRW6SMw?si=7c4msAunYsD_Myd6"
                loading="lazy"
                themeplay="true"
              />
            </div>
          </VerticalSwiperV2>
        <SnapSection light>
          <NewsV2 className={styles.artistSection} title="Artists" subtitle="Empowering artists is at the heart of what we do." type={HOMEPAGE_DEFAULT_CATEGORY[0]} category={HOMEPAGE_DEFAULT_CATEGORY[2]} link={FUNDING_NETWORK_ARTIST} artist buttonTitle="Apply Now"/>
        </SnapSection>
        <SnapSection>
          <LabelTestimonials light className={styles.labelSection} title="Labels & Distributors" subtitle="Tailor your deal to meet your unique goals—whether you're funding operations, signing new talent, or buying out of a bad deal." link={FUNDING_NETWORK_LABEL} buttonTitle="Apply Now"/>
        </SnapSection>
        <CTASection title="Let’s get started" subtitle="more Choices. better Funding." primaryButton={FUNDING_NETWORK} secondaryButton={DEAL_COMPARISON} primaryButtonLabel={<p>Get New beatBread Offers</p>} secondaryButtonLabel={<p>Compare Outside Offers</p>}/>
      </>
    );
  }
}

export default HomeV3;
